module.exports = __webpack_public_path__ + "static/media/loreal.9bd32909.png";